module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LehhlG/tc-custom/9780830873029.jpg?1696024482662",
      "alt": "This image is the cover for the book A Pastoral Rule for Today"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Pastoral Rule for Today\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("The pastoral office has always been a difficult calling.")]), _vm._v(" Today, the pastor is often asked to fulfill multiple roles: preacher, teacher, therapist, administrator, CEO. How can pastors thrive amid such demands? What is needed is a contemporary pastoral rule: a pattern for ministry that both encourages pastors and enables them to focus on what is most important in their pastoral task. This book, coauthored by three experts with decades of practical experience, explains how relying on a pastoral rule has benefited communities throughout the church's history and how such rules have functioned in the lives and work of figures such as Augustine, Calvin, Wesley, and Bonhoeffer. It also provides concrete advice on how pastors can develop and keep a rule that will help both them and their congregations to flourish.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John P. Burgess, Jerry Andrews, Joseph D. Small\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("John P. Burgess (PhD, University of Chicago) is James Henry Snowden Professor of Systematic Theology at Pittsburgh Theological Seminary. He is the author of several books, including "), _c('em', [_vm._v("Holy Rus': The Rebirth of Orthodoxy in the New Russia")]), _vm._v(", "), _c('em', [_vm._v("Encounters with Orthodoxy: How Protestant Churches Can Reform Themselves Again")]), _vm._v(", and "), _c('em', [_vm._v("Why Scripture Matters: Reading the Bible in a Time of Church Conflict")]), _vm._v(".")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0